import { connect } from 'react-redux';
import { showAddModalOnAddressBook as onClick } from 'redux/modules/address/actions';
import AddAddressButton from 'components/Address/common/AddAddressButton';

export default connect((state, props) => ({ ...props }), { onClick })(AddAddressButton);
